
 <template>
	<div class="window">
        <div class="header"><span v-html="translation.wprowadz_kod"></span>
            <a class="description" @click="openDescription"><information-circle-icon class="icon"/></a>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <h2 v-html="translation.skanuj_kod"></h2>
            <div class="help-box mt2x">
                <div class="help-text" v-html="translation.help7"></div>
            </div>
            
            <div class="video-container" v-show="isScanning">
                <video 
                    ref="videoRef" 
                    autoplay 
                    muted 
                    playsinline>
                </video>
                <div class="scanner-overlay" v-show="isScanning"></div>
            </div>
    
            <canvas ref="canvasRef"></canvas>
            <transition name="fade">
                <div 
                    :class="['status', statusClass]"
                    :key="statusMessage">
                    {{ statusMessage }}
                </div>
            </transition>
        
            <div class="alert-box" :class="(errorMessage!='')?'visible':''">
                <div class="alert-text">
                    <div class="line2">{{ errorMessage }}</div>
                </div>
            </div>
        </div>
        <a class="back-screen" @click="doNowejGry"><chevron-left-icon class="icon" /><span v-html="translation.back"></span></a>
    </div>
</template>




<script>

import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon, InformationCircleIcon, ChevronLeftIcon } from '@heroicons/vue/24/solid';
import jsQR from 'jsqr'
import axios from 'axios'

export default {
    name: 'ScanQRCode',
    props: {
        maxHistoryItems: {
            type: Number,
            default: 10
        },
        showAlert: {
            type: Boolean,
            default: true
        },
        language: String
    },
    components: { 
        Cog6ToothIcon,
        InformationCircleIcon,
        ChevronLeftIcon
    },
    emits: ['qr-scanned', 'camera-started', 'camera-stopped', 'error', 'show-spinner', 'go-nowa-gra'],
    data() {
        return {
            stream: null,
            isScanning: false,
            statusMessage: 'Kliknij "Uruchom kamerę" aby rozpocząć skanowanie',
            statusClass: 'status-info',
            isCameraSupported: true,
            scanHistory: [],
            animationId: null,
            context: null,
            lastScannedCode: '',
            lastScanTime: 0,

            lang: localStorage.getItem('language'),
            translation: pl,
            code: '',
            timer: false,
            errorMessage: '',
            theme: localStorage.getItem('theme'),
        }
    },
    computed: {
        reversedScanHistory() {
            return [...this.scanHistory].reverse()
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }

        // Sprawdź czy przeglądarka obsługuje getUserMedia
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            this.updateStatus('Twoja przeglądarka nie obsługuje dostępu do kamery', 'error')
            this.isCameraSupported = false
            this.$emit('error', { 
                type: 'browser-support', 
                message: 'Przeglądarka nie obsługuje getUserMedia' 
            })
        }
    },
    mounted() {
        // Inicjalizacja canvas context po mounted
        if (this.$refs.canvasRef) {
            this.context = this.$refs.canvasRef.getContext('2d')
        }
        this.startCamera();
    },
    beforeUnmount() {
        this.stopCamera()
    },
    methods: {
        updateStatus(message, type = 'info') {
            this.statusMessage = message
            this.statusClass = `status-${type}`
        },
        async tryJoinGame (code='', proba=1) {
            try {
                this.$emit('show-spinner', true);
                var data = new FormData();
                data.append('method', 'apply-to-game');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('lang', this.lang);
                data.append('hash', code);
                data.append('unlocked', localStorage.getItem('alreadypaid'));

                await axios.post('https://gra.wrealizacji.pl/api3.php', data)
                .then((res) => {
                    if (res.data.type == 'error' && res.data.message!='') {
                        this.$emit('show-spinner', false);
                        this.errorMessage = this.translation.nieprawidlowy_kod_gry;
                    }
                    else if (res.data.type != 'success' && proba<10) {
                        proba++;
                        setTimeout(function () { 
                            this.tryJoinGame(proba) 
                        }.bind(this), 1000)
                    } else if (res.data.type != 'success' && proba>=10) {
                        proba++;
                        this.errorMessage = this.translation.blad_polaczenia;
                        this.$emit('show-spinner', false);
                    } else {
                        this.errorMessage = '';
                        
                        /*
                        zapisuje dane do polaczenia
                        */
                        sessionStorage.removeItem('blik');
                        localStorage.setItem('game-settings-hash', res.data.game.hash);
                        localStorage.setItem('game-hash-confirmed', res.data.game.hash);
                        localStorage.setItem('game-settings-imie1', res.data.game.name1);
                        localStorage.setItem('game-settings-imie2', res.data.game.name2);
                        localStorage.setItem('game-settings-unlocked', localStorage.getItem('paid-game'));
                        localStorage.setItem('game-offset', "0");
                        
                        /*
                        zapisuje konfiguracje poziomow
                        */
                        let obj = {}
                        for(let level=1; level<=res.data.levels.length; level++) {
                            for(let sublevel = 1; sublevel<=3; sublevel++) {
                                obj = {
                                    zgodnosc: 0,
                                    status: 0,
                                    unlocked: (level<=3 && sublevel==1)?'yes':localStorage.getItem('paid-game'),
                                    name: res.data.levels[level-1].name,
                                    position:level,
                                    wynik: -1,
                                    ID: res.data.levels[level-1].ID
                                }
                                localStorage.setItem('levels-'+level+'-'+sublevel, JSON.stringify(obj));
                            }
                        }

                        /*
                        przekierowuje na pole z kodem qr i blikiem do przepisania
                        */
                        this.$emit('show-spinner', false);
                        this.$emit('go-to-poziomy');
                    }
                }).catch((error) => {
                    console.log(error);
                    this.errorMessage = this.translation.blad_polaczenia;
                    this.spinner = false;
                });
            } catch (err) {
                proba++;
                if (proba < 10) {
                    setTimeout(function () { 
                        this.tryJoinGame(proba) 
                    }.bind(this), 1000) 
                } else {
                    this.errorMessage = this.transition.blad_polaczenia;
                    this.spinner = false;
                }
            }
        },

        truncateText(text, maxLength) {
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },

        async startCamera() {
            try {
                this.updateStatus('Uruchamianie kamery...', 'info')
        
                this.stream = await navigator.mediaDevices.getUserMedia({ 
                    video: { 
                        facingMode: 'environment' // Preferuj tylną kamerę
                    } 
                })
        
                this.$refs.videoRef.srcObject = this.stream
        
                this.$refs.videoRef.onloadedmetadata = () => {
                    const canvas = this.$refs.canvasRef
                    canvas.width = this.$refs.videoRef.videoWidth
                    canvas.height = this.$refs.videoRef.videoHeight
                    this.context = canvas.getContext('2d')
          
                    this.isScanning = true
                    this.updateStatus('Skieruj kamerę na kod QR...', 'info')
                    this.$emit('camera-started')
                    this.scanQR()
                }  
            } catch (err) {
                console.error('Błąd dostępu do kamery:', err)
                const errorMsg = 'Nie można uzyskać dostępu do kamery. Sprawdź uprawnienia.'
                this.updateStatus(errorMsg, 'error')
                this.$emit('error', { type: 'camera-access', message: errorMsg, error: err })
            }
        },

        stopCamera() {
            this.isScanning = false
      
            if (this.animationId) {
                cancelAnimationFrame(this.animationId)
                this.animationId = null
            }
      
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop())
                this.stream = null
            }
      
            if (this.$refs.videoRef) {
                this.$refs.videoRef.srcObject = null
            }
      
            this.updateStatus('Kamera zatrzymana', 'info')
            this.$emit('camera-stopped')
        },

        scanQR() {
            if (!this.isScanning) return
      
            const video = this.$refs.videoRef
            const canvas = this.$refs.canvasRef
      
            if (video.readyState === video.HAVE_ENOUGH_DATA) {
                this.context.drawImage(video, 0, 0, canvas.width, canvas.height)
                const imageData = this.context.getImageData(0, 0, canvas.width, canvas.height)
        
                try {
                    const code = jsQR(imageData.data, imageData.width, imageData.height)
          
                    if (code && code.data != '') {
                        // Sprawdź czy to nie jest ten sam kod zeskanowany niedawno (debouncing)
                        const now = Date.now()
                        if (code.data !== this.lastScannedCode || now - this.lastScanTime > 2000) {
                            this.lastScannedCode = code.data
                            this.lastScanTime = now
              
                            this.updateStatus('Kod QR znaleziony!', 'success')
                            this.$emit('show-spinner', true);

                            this.tryJoinGame(code.data);
              
                            // Po zamknięciu alertu, wznów skanowanie po krótkiej przerwie
                            setTimeout(() => {
                                if (this.isScanning) {
                                    this.updateStatus('Skieruj kamerę na kod QR...', 'info')
                                }
                            }, 1000)
                        }
                    }
                } catch (error) {
                    console.error('Błąd dekodowania QR:', error)
                    this.$emit('error', { type: 'decode-error', message: 'Błąd dekodowania', error })
                }
            }
      
            // Kontynuuj skanowanie
            if (this.isScanning) {
                this.animationId = requestAnimationFrame(this.scanQR)
            }
        },

        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        doNowejGry() {
            clearTimeout(this.timer)
            this.$emit('go-nowa-gra');
        },


    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
.qr-scanner {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  text-align: center;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

h1 {
  color: #333;
  margin-bottom: 30px;
  font-size: 2.2em;
}

.video-container {
  position: relative;
  display: inline-block;
  margin: 20px 0;
}

video {
  width: 100%;
  max-width: 400px;
  border: 3px solid var(--bs-gradient-to);
  border-radius: 10px;
  background: #f0f0f0;
}

canvas {
  display: none;
}

.scanner-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  border: 2px solid #fff;
  pointer-events: none;
}

.scanner-overlay::before,
.scanner-overlay::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
}

.scanner-overlay::before {
  top: -2px;
  left: -2px;

  border-top: 4px solid var(--bs-gradient-to);
  border-left: 4px solid var(--bs-gradient-to);
}

.scanner-overlay::after {
  bottom: -2px;
  right: -2px;
  border-bottom: 4px solid var(--bs-gradient-to);
  border-right: 4px solid var(--bs-gradient-to);
}

.controls {
  margin: 20px 0;
}

button {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  margin: 10px;
  transition: transform 0.2s, box-shadow 0.2s;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.clear-history-btn {
  background: linear-gradient(45deg, #e74c3c, #c0392b);
  font-size: 14px;
  padding: 8px 16px;
  margin-top: 10px;
}

.status {
  margin: 20px 0;
  padding: 10px;
  border-radius: 8px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.status-info {
  background: #e3f2fd;
  color: #1976d2;
}

.status-error {
  background: #ffebee;
  color: #d32f2f;
}

.status-success {
  background: #e8f5e8;
  color: #388e3c;
}

.instructions {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin: 20px 0;
  text-align: left;
}

.instructions h3 {
  margin-top: 0;
  color: #555;
}

.instructions ul {
  margin: 0;
  padding-left: 20px;
}

.instructions li {
  margin: 5px 0;
}

.scan-history {
  margin-top: 20px;
  text-align: left;
}

.scan-history h3 {
  color: #555;
  margin-bottom: 10px;
}

.scan-item {
  background: #f9f9f9;
  padding: 12px;
  margin: 8px 0;
  border-radius: 8px;
  border-left: 4px solid #667eea;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.scan-item:hover {
  background: #f0f0f0;
}

.scan-time {
  color: #888;
  font-size: 12px;
  margin-bottom: 5px;
}

.scan-data {
  font-size: 14px;
  word-break: break-all;
  line-height: 1.4;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Responsywność */
@media (max-width: 600px) {
  .qr-scanner {
    padding: 20px;
    margin: 10px;
  }
  
  h1 {
    font-size: 1.8em;
  }
  
  video {
    max-width: 100%;
  }
  
  .scanner-overlay {
    width: 150px;
    height: 150px;
  }
  
  button {
    padding: 10px 20px;
    font-size: 14px;
    margin: 5px;
  }
}

/*
moje
*/

a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
    position:absolute;
}
a.back-screen span {
    padding-left: 20px;
}

.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

</style>